import React, {
  useEffect,
  useState,
  useCallback,
  memo
} from 'react';
import img from '../assets/footer-logo.webp';
import img1 from '../assets/insta-img.webp';
import img2 from '../assets/facebook-img.svg';

const Footer = () => {
  const [showChatIcon, setShowChatIcon] = useState(false);
  const [showPopupIframe, setShowPopupIframe] = useState(false);
  const [activeIframe, setActiveIframe] = useState('');
  const [iframeReady, setIframeReady] = useState({
    'try-now': false,
    'subscribe-now': false,
  });
  const [preloaded, setPreloaded] = useState(false);
  const [showContent, setShowContent] = useState(false);

  // Debounced scroll handler
  const handleScroll = useCallback(() => {
    requestAnimationFrame(() => {
      setShowChatIcon(window.scrollY > 0);
    });
  }, []);

  const closePopup = useCallback(() => {
    setShowPopupIframe(false);
    setActiveIframe('');
  }, []);

  const handleIframeLoad = useCallback((key) => {
    setIframeReady((prev) => ({ ...prev, [key]: true }));
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowContent(true);
    }, 0);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  useEffect(() => {
    document.body.style.overflow = showPopupIframe ? 'hidden' : 'auto';
  }, [showPopupIframe]);

  useEffect(() => {
    const handleClick = (e) => {
      const target = e.target.closest('.landing-slider-button, .show_paid_plans');
      if (!target) return;

      e.preventDefault();
      const key = target.classList.contains('landing-slider-button') ? 'try-now' : 'subscribe-now';
      setActiveIframe(key);
      setShowPopupIframe(true);
    };

    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.type === 'closeIframe') {
        closePopup();
      } else if (event.data?.type === 'submitTrialForm') {
        window.location.href = 'https://poolwater-pro.com/thank-trial/';
      }
    };
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [closePopup]);

  useEffect(() => {
    const onLoad = () => {
      setTimeout(() => setPreloaded(true), 3000); // 3s delay
    };

    if (document.readyState === 'complete') {
      onLoad();
    } else {
      window.addEventListener('load', onLoad);
      return () => window.removeEventListener('load', onLoad);
    }
  }, []);

  return (
    <>
      {showContent && (
        <footer>
          <div className="container">
            <div className="row">
              <div className="col-md-4 mb-32">
                <a href="#">
                  <img src={img} alt="Footer Logo" className="footer-logo" loading="lazy" />
                </a>
                <p className="footer-p">
                  PoolWater-Pro Test-Strip technologies enable fast, convenient and accurate water analysis for your pool.
                </p>
              </div>
              <div className="col-md-8">
                <ul className="footer-ul flex-wrap">
                  <li><a href="https://poolwater-pro.com/privacy-policy/">Privacy Policy</a></li>
                  <li><a href="https://poolwater-pro.com/terms-of-use/">Terms of Use</a></li>
                  <li><a href="javascript:void(0);" className="show_paid_plans">See Our Pricing</a></li>
                </ul>
              </div>
              <div className="col-12">
                <div className="sub-footer">© 2025 PoolWater-Pro. All rights reserved.</div>
              </div>
            </div>
          </div>
        </footer>
      )}

      {showPopupIframe && (
        <div className="popup-overlay active" onClick={closePopup}>
          {!iframeReady[activeIframe] && <div className="loader"></div>}
          {iframeReady[activeIframe] && (
            <iframe
              src={`https://poolwater-pro.com/react-snippet-endpoint.php/?open=${activeIframe}`}
              title={`Popup ${activeIframe}`}
              onLoad={() => handleIframeLoad(activeIframe)}
              sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
              className={`popup-iframe ${activeIframe === 'subscribe-now' ? 'popup-subscribe' : ''}`}
              scrolling="yes"
            />
          )}
        </div>
      )}

      {preloaded && (
        <div style={{ position: 'absolute', top: '-9999px', left: '-9999px', height: 0, overflow: 'hidden' }}>
          <iframe
            src="https://poolwater-pro.com/react-snippet-endpoint.php/?open=try-now"
            title="Preload Try Now"
            onLoad={() => handleIframeLoad('try-now')}
            sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
          />
          <iframe
            src="https://poolwater-pro.com/react-snippet-endpoint.php/?open=subscribe-now"
            title="Preload Subscribe Now"
            onLoad={() => handleIframeLoad('subscribe-now')}
            sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
          />
        </div>
      )}

      {showChatIcon && (
        <a href="#!" className="landing-slider-button fs-btn-signup-floating">
          <span>Try for Free!</span>
        </a>
      )}

      {/* Styles remain unchanged */}
       <style>{`
         .popup-overlay {
           position: fixed;
           top: 0;
           left: 0;
           width: 100vw;
           height: 100vh;
           background-color: rgba(72, 72, 72, 0.48);
           backdrop-filter: blur(2px);
           z-index: 100000;
           display: flex;
           align-items: center;
           justify-content: center;
         }

         .popup-iframe {
           width: 90%;
           height: 100%;
           max-width: 600px;
           max-height: calc(100vh - 80px);
           border: none;
           border-radius: 12px;
           background: white;
           box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
           transition: opacity 0.3s ease;
           overflow: auto;
         }

         .popup-subscribe {
           /* Custom height for subscribe iframe on mobile */
         }

         .loader {
           z-index: 100002;
           position: absolute;
           top: 50%;
           left: 50%;
           transform: translate(-50%, -50%);
           border: 5px solid #f3f3f3;
           border-top: 5px solid #3498db;
           border-radius: 50%;
           width: 48px;
           height: 48px;
           animation: spin 1s linear infinite;
         }

         @keyframes spin {
           0% { transform: rotate(0deg); }
           100% { transform: rotate(360deg); }
         }

         .fs-btn-signup-floating {
           position: fixed;
           bottom: 24px;
           right: 24px;
           z-index: 99999;
           background-color: #E22B2B;
           border: none;
           padding: 0;
           cursor: pointer;
           border-radius: 100%;
           box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.5);
           text-decoration: none;
           width: 80px;
           height: 77px;
           display: flex;
           align-items: center;
           justify-content: center;
         }

         .fs-btn-signup-floating span {
           color: #ffffff;
           transform: rotateZ(-10deg);
           width: 88%;
           font-family: "Poppins", Sans-serif;
           font-weight: 600;
           font-size: 12px;
           text-align: center;
           line-height: 1.2;
         }

         @media (max-width:767px){
           .popup-subscribe{
             max-height: none !important;
             min-height:650px;
             height:auto;
           }   
         }

         @media (max-width:575px){
           .popup-iframe {
             max-width: 100%;
             max-height: calc(100vh - 20vh);
           }   
         }
         #chatbot-widget-floating{
           display:none !important;
         }
       `}</style>
    </>
  );
};

export default memo(Footer);
